import type { NotificationKind } from './api';

/**
 * Client-owned routing for notifications. The server stores only `kind` +
 * `jobId` (no client URL), so each client derives its own route here — change
 * the app's routes and only this file moves.
 */

/**
 * Where tapping a notification should land. cancelled/removed have no job of
 * the driver's left to open, so they go to the dispatch list; everything else
 * deep-links to the job detail (falling back to the list if the job id is
 * missing). All kinds are navigable — the destination is the only difference.
 */
export function routeFor(kind: NotificationKind, jobId?: string | null): string {
  if (kind === 'cancelled' || kind === 'removed') return '/my-dispatch';
  return jobId ? `/my-dispatch/${jobId}` : '/my-dispatch';
}

/** Fallback title (mirrors the server copy) for when a foreground push forwards
 *  only `data` and no `title` — so we can still show a meaningful toast. */
export function titleForKind(kind?: string): string {
  switch (kind) {
    case 'assigned': return 'New job assigned';
    case 'rescheduled': return 'Job time changed';
    case 'updated': return 'Job updated';
    case 'removed': return 'Job removed';
    case 'cancelled': return 'Job cancelled';
    case 'completed': return 'Job completed';
    default: return 'New notification';
  }
}
